import React from 'react';
import { boards } from '../mock';
import HeroContent from './HeroContent';
import HeroImage from './HeroImage';

export default function Hero() {
  const marqueeItems = [...boards, ...boards, ...boards, ...boards];
  return (
    <section id="home" className="relative overflow-hidden">
      <div className="absolute inset-0 grid-dots opacity-60 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-10 pb-16 lg:pt-16 lg:pb-24 grid lg:grid-cols-12 gap-10 items-center relative">
        <HeroContent />
        <HeroImage />
      </div>

      <div className="border-y-2 border-[#2C3E50] bg-[#2C3E50] text-[#FFF8EC] overflow-hidden">
        <div className="marquee py-3">
          {marqueeItems.map((b, i) => (
            <div key={`${b}-${i}`} className="flex items-center gap-3 px-6 shrink-0">
              <span className="w-2 h-2 rounded-full bg-[#F4B93E]" />
              <span className="font-bold tracking-wider">{b}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
